let sliders = document.querySelectorAll('.splide:not(.custom-slider)')

if((sliders && sliders.length > 0)){
	(async () => {
		const spliders = await import('./sliders');
		spliders.default(sliders);
	})();
}